// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Redux
import { RootState } from "reduxFunctionality/index";
import { useSelector } from "react-redux";
// MARK: Types
import ReduxStyleguide from "types/redux/styleguide";
import OutcomesGridItems from "types/fields/matrix/grids/outcomesGrid";
// MARK: Components
import Item from "./item";
import { Container } from "../shared";

// MARK: Styled Components
interface GridListProps {
  gridGap: number;
}

const List = styled.ul<GridListProps>`
  display: grid;
  grid-gap: ${({ gridGap }) => gridGap}px;
  width: 100%;
  height: auto;
  margin-block-start: 0em;
  margin-block-end: 0em;
  margin-inline-start: 0em;
  margin-inline-end: 0em;
  padding-inline-start: 0em;

  @media (max-width: 599px) {
    grid-template-columns: 1fr;
  }

  @media (min-width: 600px) and (max-width: 1239px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: 1240px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

// MARK: React Component
// Props
interface Props {
  listArialabel: string;
  items: OutcomesGridItems;
  HTMLHeaderType: string;
}
// Styleguide & Datapoints
const getDatapoints = (styleguide: ReduxStyleguide) => {
  const { breakpoint, margin, containerWidth } = styleguide;
  // Determine Number of Columns
  var numberOfColumns: number;

  switch (breakpoint) {
    case 0:
      numberOfColumns = 1;
      break;
    case 1:
    case 2:
      numberOfColumns = 2;
      break;
    default:
      numberOfColumns = 3;
      break;
  }

  const itemWidth: number =
    (containerWidth - (numberOfColumns - 1) * margin) / numberOfColumns;

  return {
    itemWidth: itemWidth,
  };
};
// Component
const OutcomesGrid = ({
  listArialabel,
  items,
  HTMLHeaderType,
}: Props) => {
  // MARK: React Redux Variables
  const styleguide: ReduxStyleguide = useSelector(
    (state: RootState) => state.styleguide
  );
  // MARK: Variables
  const { margin } = styleguide;
  const { itemWidth } = getDatapoints(styleguide);
  // MARK: Functionality
  const listItems = () => {
    var listItems: Array<any> = [];

    if (items === undefined) {
      return listItems;
    }

    items.forEach((item, _) => {
      listItems.push(
        <Item
          key={item.title}
          item={item}
          itemWidth={itemWidth}
          HTMLHeaderType={HTMLHeaderType}
        />
      );
    });
    return listItems;
  };
  // MARK: Render
  return (
    <Container aria-label={listArialabel} margin={margin}>
      <List
        aria-label={listArialabel}
        gridGap={margin}
        role={"list"}
        itemScope
        itemType="https://schema.org/SiteNavigationElement"
      >
        {listItems()}
      </List>
    </Container>
  );
};

export default OutcomesGrid;
